/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2023
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([], function () {
	'use strict';
	// Temporary array of live widget feature specs. This can be used to quickly test a live widget feature without adding to the perspective collection
	// Example:
	// {
	// 	"containerId": "com.ibm.bi.dashboard.live-features",
	// 	"name": "summaryFeature",
	// 	"id": "com.ibm.bi.dashboard.live-features.summaryFeature",
	// 	"class": "dashboard-analytics/widgets/livewidget/features/summary/SummaryFeature"
	// }
	return [
		{
			'containerId': 'com.ibm.bi.dashboard.content-features',
			'name': 'Renderer',
			'id': 'com.ibm.bi.dashboard.content-features.renderer',
			'class': 'dashboard-core/js/view/features/content/contentView/api/impl/ContentView',
			'dependencies': ['Dashboard.API'],
			'runtimeDependencies': ['Colors', 'DashboardSettings'],
			'profiles': ['core']
		},
		{
			'containerId': 'com.ibm.bi.dashboard.content-features',
			'name': 'Properties',
			'id': 'com.ibm.bi.dashboard.content-features.properties',
			'class': 'dashboard-core/js/features/common/properties/api/impl/Properties',
			'dependencies': ['Dashboard.API'],
			'profiles': ['core']
		},
		// {	//TODO: Remove this comment when testing with PropertiesV2 feature flag turned ON
		// 	'containerId': 'com.ibm.bi.dashboard.content-features',
		// 	'name': 'Properties',
		// 	'id': 'com.ibm.bi.dashboard.content-features.propertiesV2',
		// 	'class': 'dashboard-core/js/features/common/properties/api/impl/PropertiesV2',
		// 	'dependencies': [ 'Dashboard.API'],
		// 	'profiles': ['core']
		// },
		{
			'containerId': 'com.ibm.bi.dashboard.content-features',
			'name': 'AlignPropertiesProvider',
			'id': 'com.ibm.bi.dashboard.content-features.alignPropertiesProvider',
			'class': 'dashboard-core/js/features/content/alignProperties/AlignPropertiesProvider',
			'types':['widget', 'group'],
			'dependencies': ['Properties'],
			'runtimeDependencies': ['Dashboard.Icons'],
			'profiles': ['consume']
		},
		{
			'containerId': 'com.ibm.bi.dashboard.content-features',
			'name': 'PagePropertiesProvider',
			'id': 'com.ibm.bi.dashboard.content-features.pageProperties',
			'class': 'dashboard-core/js/features/content/pageProperties/PagePropertiesProvider',
			'types':['page'],
			'dependencies': ['Properties'],
			'runtimeDependencies': ['Colors', 'Dashboard.Icons', 'internal', 'Transaction'],
			'profiles': ['consume']
		},
		{
			'containerId': 'com.ibm.bi.dashboard.content-features',
			'name': 'ContentMenu',
			'id': 'com.ibm.bi.dashboard.content-features.ContentMenu',
			'class': 'dashboard-core/js/features/dashboard/contentMenu/ContentMenu',
			'types': ['widget'],
			'profiles': ['authoring']
		},
		{
			'containerId': 'com.ibm.bi.dashboard.content-features',
			'name': 'ContentFilterPropertiesProvider',
			'id': 'com.ibm.bi.dashboard.content-features.contentFilterPropertiesProvider',
			'class': 'dashboard-core/js/features/content/contentFilter/ContentFilterPropertiesProvider',
			'dependencies': ['ContentFilter'],
			'profiles': ['consume']
		}
	];
});
